import departmentsTranslations from '../data/departments.json';

// Local storage key for dynamic translations
const STORAGE_KEY = 'departments_translations';

// Load translations from local storage
const loadLocalTranslations = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    console.error('Error loading local translations:', error);
    return {};
  }
};

// Save translations to local storage
const saveLocalTranslations = (translations) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(translations));
    return true;
  } catch (error) {
    console.error('Error saving local translations:', error);
    return false;
  }
};

// Get department translation
export const getDepartmentTranslation = (departmentName, language = 'fr') => {
  if (!departmentName) return '';
  
  // Map language codes
  const langMap = {
    'fr': 'fr',
    'en': 'en',
    'ar': 'ar',
    'fra': 'fr',
    'eng': 'en',
    'ara': 'ar'
  };
  
  const lang = langMap[language.toLowerCase()] || 'fr';
  
  // Create a translation key from the department name
  const translationKey = departmentName.trim();
  
  // Try to get from local storage first
  const localTranslations = loadLocalTranslations();
  if (localTranslations[translationKey] && localTranslations[translationKey][lang]) {
    return localTranslations[translationKey][lang];
  }
  
  // Try to get from static translations
  if (departmentsTranslations[translationKey] && departmentsTranslations[translationKey][lang]) {
    return departmentsTranslations[translationKey][lang];
  }
  
  // Return original name if no translation found
  return departmentName;
};

// Add department translation
export const addDepartmentTranslation = (departmentName, translations) => {
  try {
    if (!departmentName || !translations) {
      return { success: false, message: 'Invalid parameters' };
    }
    
    const translationKey = departmentName.trim();
    const localTranslations = loadLocalTranslations();
    
    localTranslations[translationKey] = {
      ar: translations.ar || departmentName,
      fr: translations.fr || departmentName,
      en: translations.en || departmentName
    };
    
    if (saveLocalTranslations(localTranslations)) {
      return { success: true, message: 'Translation added successfully' };
    } else {
      return { success: false, message: 'Failed to save translation' };
    }
  } catch (error) {
    console.error('Error adding department translation:', error);
    return { success: false, message: error.message };
  }
};

// Reload translations from file (for development)
export const reloadTranslations = () => {
  try {
    // Clear local storage
    localStorage.removeItem(STORAGE_KEY);
    return { success: true, message: 'Translations reloaded successfully' };
  } catch (error) {
    console.error('Error reloading translations:', error);
    return { success: false, message: error.message };
  }
};

// Export translations to file (for development/debugging)
export const saveTranslationsToFile = () => {
  try {
    const localTranslations = loadLocalTranslations();
    const allTranslations = { ...departmentsTranslations, ...localTranslations };
    
    // Create a JSON string
    const jsonString = JSON.stringify(allTranslations, null, 2);
    
    // Create a blob and download
    const blob = new Blob([jsonString], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'departments.json';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    
    return { success: true, message: 'Translations exported successfully' };
  } catch (error) {
    console.error('Error exporting translations:', error);
    return { success: false, message: error.message };
  }
};
